// Game Related
window.promises = window.promises || {}

window.nativePromiseThen = (promiseId: string, data: any, error: any) => {
  if (error) {
    window.promises[promiseId].reject(data)
  } else {
    window.promises[promiseId].resolve(data)
  }
  delete window.promises[promiseId]
}
const generateUUID = () => {
  let d = new Date().getTime()
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16)
  })
  return uuid
}
export const BrowserInfo = () => {
  const u = navigator.userAgent
  return {//移动终端浏览器版本信息
    trident: u.indexOf('Trident') > -1, // IE
    presto: u.indexOf('Presto') > -1, // opera
    webKit: u.indexOf('AppleWebKit') > -1, // apple, google
    gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, // firefox
    mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/),
    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios
    android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, // android, uc
    iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1,
    iPad: u.indexOf('iPad') > -1,
    webApp: u.indexOf('Safari') === -1,
  }
}

export const checkDevice = () => {
  // 设备检测
  const ua = navigator.userAgent.toLowerCase();
  const isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
  if (isAndroid) {
    return 'android';
  }
  const isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  if (isiOS) {
    return 'ios';
  }
  if (
    /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) ||
    [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod',
    ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  ) {
    return 'ios';
  } else if (/(Android)/i.test(navigator.userAgent)) {
    return 'android';
  }
  return 'other';
}

export const checkIsInGame = () => {
  if (window?.FreeFire || window?.webkit?.messageHandlers?.FreeFire) {
    return true;
  }
  return false;
};
export const gamePostMessage = (msg: string) => {
  const browser = {
    versions: BrowserInfo(),
    language: (
      window.navigator.language
    ).toLowerCase(),
  }
  if (browser.versions.ios || browser.versions.iPhone || browser.versions.iPad) {
    window.webkit.messageHandlers.FreeFire.postMessage(msg)
  } else if (browser.versions.android) {
    window.FreeFire.postMessage(msg)
  }
}

export const gamePromise = (key: string, value = '') => {
  return new Promise((resolve, reject) => {
    const promiseId = generateUUID()
    window.promises[promiseId] = { resolve, reject }
    const msg: any = {
      PromiseId: promiseId,
      [key]: value
    }
    gamePostMessage(JSON.stringify(msg))
  })
}
export const deepLink = (url: string, fn: Function) => {
  if (checkIsInGame()) {
    gamePostMessage(JSON.stringify({
      DeepLinkUrl: url
    }))
  } else {
    window.location.href = url;
  }
  const timer = setTimeout(() => {
    fn()
    clearTimeout(timer)
  }, 3000)
  document.addEventListener('visibilitychange', () => {
    document.hidden && clearTimeout(timer)
  }, { once: true })
}
export const game = {
  checkIsInGame,
  run: gamePromise,
  deepLink,
  checkScreenShotOpen: () => {
    if (!checkIsInGame()) {
      console.log('must run in game')
      return
    }
    return gamePromise('CanCaptureScreenshot')
  },
  runScreenShot: () => {
    if (!checkIsInGame()) {
      console.log('must run in game')
      return
    }
    return gamePromise('CaptureAndShareScreenshot')
  }
}
